export const MerchandisingProgramSeasonCategoryEnumValue = {
  None: 0,

  Spring: 1,
  Summer: 10,
  Fall: 20,
  Winter: 30,
};

export const MerchandisingProgramSeasonCategoryEnum = [
  {
    value: MerchandisingProgramSeasonCategoryEnumValue.Spring,
    order: 1,
    labelFrench: 'Printemps',
    labelEnglish: 'Spring',
  },
  {
    value: MerchandisingProgramSeasonCategoryEnumValue.Summer,
    order: 2,
    labelFrench: 'Été',
    labelEnglish: 'Summer',
  },
  {
    value: MerchandisingProgramSeasonCategoryEnumValue.Fall,
    order: 3,
    labelFrench: 'Automne',
    labelEnglish: 'Fall',
  },
  {
    value: MerchandisingProgramSeasonCategoryEnumValue.Winter,
    order: 4,
    labelFrench: 'Hiver',
    labelEnglish: 'Winter',
  },
];

export default MerchandisingProgramSeasonCategoryEnum;
